export const DEFAULT = 'default'
export const LARGE = 'large'
